import script from "./BenefitingJez.vue?vue&type=script&setup=true&lang=js"
export * from "./BenefitingJez.vue?vue&type=script&setup=true&lang=js"

import "./BenefitingJez.vue?vue&type=style&index=0&id=6bc4980d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bc4980d"]])

export default __exports__